
class NewSelectionList {
    constructor() {
        const readmore = document.querySelector('.readmore__link');
        if (!readmore) {
            return;
        }
        readmore.addEventListener('click', (e) => {
            e.preventDefault();
            const target = e.currentTarget;
            const parentList = this.findParent(target, 'newsselectionblock').querySelector('ul');
            if (target.classList.contains('preload')) {
                target.classList.remove('preload');
                this.loadMoreHits(
                    `/api/v1/newsselection/?contentRef=${target.dataset.ref}&displayOptionTag=${target.dataset.do}`,
                    (data) => {
                        let element = document.createElement('div');
                        element.insertAdjacentHTML('beforeend', data.items);
                        element = element.querySelectorAll('li');
                        [].forEach.call(element,
                            function(item) {
                                parentList.appendChild(item);
                            });
                        this.toggle(target,parentList);
                    });
            } else {
                this.toggle(target,parentList);
            }

          
        });        
    }
    toggle(target,parentList) {
        const toggleTexts = target.querySelectorAll('.readmore__link__toggle');
        var sneakyItems = parentList.querySelectorAll('.newsselectionblock__newslist__item--sneaky');
        [].forEach.call(sneakyItems, (item) => {
            item.classList.toggle('hidden');
        });
        [].forEach.call(toggleTexts, (text) => {
            text.classList.toggle('hidden');
        });  
    }
    loadMoreHits(url, callback) {
        var headers = {
            'pragma': 'no-cache',
            'cache-control': 'no-cache',
        };
        fetch(url,
            {
                headers: headers,
                method: 'GET',
                credentials: 'include'

            }).then(resp => {
            return resp.clone().json();
        }).then(data => {
            callback(data);
        });
    }
    findParent(el, className) {
        while (el && !el.classList.contains(className)) {
            el = el.parentElement || el.parentNode;
        }
        return el;
    }
}
document.addEventListener("DOMContentLoaded", function () {
    new NewSelectionList();
});


// WEBPACK FOOTER //
// ./Components/Blocks/NewsBlock/newsselectionblock.js